import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import Portada from '../pages/Portada';
import DatosPersonales from '../pages/DatosPersonales';
import { useDarkMode } from './DarkModeProvider';

export default function PortadaPadre({ token, idDocente, periodoId, rol }) {

    const { darkMode } = useDarkMode();

    const [portadaDocente, setPortadaDocente] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    const dynamicStyles = darkMode ? darkModeStyles : lightModeStyles;
    const esDocente = rol === 'Docente'

    const formatearFechaCorte = (fecha) => {
        if (!fecha || typeof fecha !== 'string') return '-'

        if (fecha.includes('-')) {
            const [anio, mes, dia] = fecha.split('-')
            if (anio && mes && dia) {
                return `${dia.padStart(2, '0')}/${mes.padStart(2, '0')}/${anio}`
            }
        }

        if (fecha.includes('/')) {
            const partes = fecha.split('/')
            if (partes.length === 3) {
                const [dia, mes, anio] = partes
                return `${dia.padStart(2, '0')}/${mes.padStart(2, '0')}/${anio}`
            }
        }

        return fecha
    }

    useEffect(() => {
        if (!periodoId) {
            setLoading(false)
            return
        }

        fetch(`${process.env.REACT_APP_API_URL}/docente-portada/${idDocente}/${periodoId}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Error en la solicitud')
                }
                return response.json()
            })
            .then(async (res) => {
                if (esDocente && res?.estado_actual === 'nuevo') {
                    try {
                        const transitionResponse = await fetch(
                            `${process.env.REACT_APP_API_URL}/docente-estado/transicionar-ingreso/${idDocente}/${periodoId}/`,
                            {
                                method: 'POST',
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": `Bearer ${token}`
                                }
                            }
                        )

                        if (transitionResponse.ok) {
                            setPortadaDocente({ ...res, estado_actual: 'ingreso' })
                            return
                        }
                    } catch (transitionError) {
                        console.log(transitionError)
                    }
                }

                setPortadaDocente(res)
            })
            .catch((error) => {
                console.log(error)
                setError(error.message)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [esDocente, idDocente, periodoId, token])

    return (
        <>
            <DatosPersonales token={token} portadaDocente={portadaDocente} loading={loading}/>
            <div className="mb-2">
                {loading ? null : (
                    <>
                        <h2 className="pb-2" style={{ ...dynamicStyles.title, fontSize: '1.45rem' }}>Situación de Revista</h2>
                        {portadaDocente && (
                            <ul style={styles.list}>
                                <li style={styles.listItem}>
                                    <span style={styles.boldText}>Fecha de corte:</span> {formatearFechaCorte(portadaDocente.fecha_corte)}
                                </li>
                                <li style={styles.listItem}>
                                    <span style={styles.boldText}>Unidad Académica:</span> {portadaDocente.unidad_academica_nombre || '-'}
                                </li>
                                <li style={styles.listItem}>
                                    <span style={styles.boldText}>Planta Básica:</span> {portadaDocente.situacion_de_revista || '-'}
                                </li>
                                <li style={styles.listItem}>
                                    <span style={styles.boldText}>Categoría:</span> {portadaDocente.categoria || '-'}
                                </li>
                                <li style={styles.listItem}>
                                    <span style={styles.boldText}>Función:</span> {portadaDocente.funcion_nombre || '-'}
                                </li>
                            </ul>
                        )}
                    </>
                )}
            </div>
            <Portada token={token} portadaDocente={portadaDocente} loading={loading} periodoId={periodoId}/>
        </>
    )
};

const lightModeStyles = {
    title: {
        color: '#A23C41',
        borderBottom: '4px solid #646354'
    }
};

const darkModeStyles = {
    title: {
        borderBottom: '4px solid #495057'
    }
};

const styles = {
    list: {
        paddingLeft: '20px',
        listStyleType: 'disc'
    },
    listItem: {
        marginBottom: '5px'
    },
    boldText: {
        fontWeight: 'bold',
        fontSize: 18
    }
};